// extracted by mini-css-extract-plugin
module.exports = {"addTalentWrapper":"SearchByNameAndEmail_addTalentWrapper__33O-_","talent":"SearchByNameAndEmail_talent__38qI5"};